import request from "@user-center/utils/request";
import type { AxiosPromise } from "axios";
import { get } from "lodash-es";
import store from "@user-center/store";
import { isToTransfer, getCurrentLocaleTransferCode } from "@user-center/utils/i18n.ts"
import { getToken } from "@user-center/utils/auth";
import { getMallApiBaseUrl } from "@user-center/utils/qiankun";

let frontServiceUrl="/frontserver";
function getMallBaseURL() {
  const mallApiBaseUrl = getMallApiBaseUrl();
  // 店铺配置里声明了 mallApiUrl 时优先直连真实 mall API。
  if (mallApiBaseUrl) {
    return mallApiBaseUrl;
  }

  // 没有 mallApiUrl 时回退到站内 /mall 代理，避免拼出 /collectionSite/mall/mall 这类错误路径。
  return "/";

}
// 游客登录商城用户
export function getMallUserInfo(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/portal/auth/loginTourists?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}

// 商城获取1688订单
export function queryJyOrderAlibaba(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/queryJyOrderAlibaba2?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式

    data: {
      ...data,
      ___transferConfig: isToTransfer() ? {
        "language": getCurrentLocaleTransferCode(),
        "transferKeysConfig": JSON.stringify([
          [
            "data.convertData.dataList", "statusName"
          ],
          [
            "data.convertData.dataList", "warehouseName"
          ],
          [
            "data.convertData.dataList", "detailResults", "spec"
          ],
          [
            "data.convertData.dataList", "detailResults", "title"
          ],
          [
            "data.originalData.dataList", "statusName"
          ],
          [
            "data.originalData.dataList", "warehouseName"
          ],
          [
            "data.originalData.dataList", "detailResults", "spec"
          ],
          [
            "data.originalData.dataList", "detailResults", "title"
          ],
          [
            "data.dataList", "statusName"
          ],
          [
            "data.dataList", "warehouseName"
          ],
          [
            "data.dataList", "detailResults", "spec"
          ],
          [
            "data.dataList", "detailResults", "title"
          ],
          // [
          //   "data.dataList","warehouseName"
          // ],

        ])
      } : undefined
    },
  });
}

// 商城获取 1688 订单（新版订单页）
export function queryJyOrderAlibaba3(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/queryJyOrderAlibaba3?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              ["data.convertData.dataList", "statusName"],
              ["data.convertData.dataList", "headerDisplayStatusName"],
              ["data.convertData.dataList", "displayStatusName"],
              ["data.convertData.dataList", "refundStatusName"],
              ["data.convertData.dataList", "warehouseName"],
              ["data.convertData.dataList", "detailResults", "spec"],
              ["data.convertData.dataList", "detailResults", "title"],
              ["data.convertData.dataList", "detailResults", "displayStatusName"],
              ["data.convertData.dataList", "detailResults", "refundStatusName"],
              ["data.convertData.dataList", "detailResults", "showStatusName"],

              ["data.originalData.dataList", "statusName"],
              ["data.originalData.dataList", "headerDisplayStatusName"],
              ["data.originalData.dataList", "displayStatusName"],
              ["data.originalData.dataList", "refundStatusName"],
              ["data.originalData.dataList", "warehouseName"],
              ["data.originalData.dataList", "detailResults", "spec"],
              ["data.originalData.dataList", "detailResults", "title"],
              ["data.originalData.dataList", "detailResults", "displayStatusName"],
              ["data.originalData.dataList", "detailResults", "refundStatusName"],
              ["data.originalData.dataList", "detailResults", "showStatusName"],

              ["data.dataList", "statusName"],
              ["data.dataList", "headerDisplayStatusName"],
              ["data.dataList", "displayStatusName"],
              ["data.dataList", "refundStatusName"],
              ["data.dataList", "warehouseName"],
              ["data.dataList", "detailResults", "spec"],
              ["data.dataList", "detailResults", "title"],
              ["data.dataList", "detailResults", "displayStatusName"],
              ["data.dataList", "detailResults", "refundStatusName"],
              ["data.dataList", "detailResults", "showStatusName"],
            ]),
          }
        : undefined,
    },
  });
}

// 商城获取 1688 新版订单页状态筛选
export function queryJyOrderAlibaba3StatusFilters(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/queryJyOrderAlibaba3StatusFilters?mall=1&hiddenErrTip=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 商城统一订单详情（新版统一订单列表详情页）
export function queryLocalOrderDetail(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/queryLocalOrderDetail?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              ["data.convertData", "statusName"],
              ["data.convertData", "headerDisplayStatusName"],
              ["data.convertData", "displayStatusName"],
              ["data.convertData", "orderStatusName"],
              ["data.convertData", "refundStatusName"],
              ["data.convertData", "shopName"],
              ["data.convertData", "sourceMarket"],
              ["data.convertData", "warehouseName"],
              ["data.convertData", "payMsg"],
              ["data.convertData", "orderRemark"],
              ["data.convertData", "detailResults", "spec"],
              ["data.convertData", "detailResults", "title"],
              ["data.convertData", "detailResults", "displayStatusName"],
              ["data.convertData", "detailResults", "refundStatusName"],
              ["data.convertData", "detailResults", "showStatusName"],

              ["data.originalData", "statusName"],
              ["data.originalData", "headerDisplayStatusName"],
              ["data.originalData", "displayStatusName"],
              ["data.originalData", "orderStatusName"],
              ["data.originalData", "refundStatusName"],
              ["data.originalData", "shopName"],
              ["data.originalData", "sourceMarket"],
              ["data.originalData", "warehouseName"],
              ["data.originalData", "payMsg"],
              ["data.originalData", "orderRemark"],
              ["data.originalData", "detailResults", "spec"],
              ["data.originalData", "detailResults", "title"],
              ["data.originalData", "detailResults", "displayStatusName"],
              ["data.originalData", "detailResults", "refundStatusName"],
              ["data.originalData", "detailResults", "showStatusName"],

              ["data", "statusName"],
              ["data", "headerDisplayStatusName"],
              ["data", "displayStatusName"],
              ["data", "orderStatusName"],
              ["data", "refundStatusName"],
              ["data", "shopName"],
              ["data", "sourceMarket"],
              ["data", "warehouseName"],
              ["data", "payMsg"],
              ["data", "orderRemark"],
              ["data", "detailResults", "spec"],
              ["data", "detailResults", "title"],
              ["data", "detailResults", "displayStatusName"],
              ["data", "detailResults", "refundStatusName"],
              ["data", "detailResults", "showStatusName"],
            ]),
          }
        : undefined,
    },
  });
}

// 商城获取微店订单
export function queryJyOrderWeidian(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/queryJyOrderWeidian?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            // 兼容不同返回结构：dataList 可能在 convertData 下或根节点下
            transferKeysConfig: JSON.stringify([
              ["data.convertData.dataList", "statusName"],
              ["data.convertData.dataList", "orderStatusName"],
              ["data.convertData.dataList", "shopName"],
              ["data.convertData.dataList", "detailResults", "spec"],
              ["data.convertData.dataList", "detailResults", "title"],

              ["data.dataList", "statusName"],
              ["data.dataList", "orderStatusName"],
              ["data.dataList", "shopName"],
              ["data.dataList", "detailResults", "spec"],
              ["data.dataList", "detailResults", "title"],
            ]),
          }
        : undefined,
    },
  });
}

// 商城获取1688购物车
export function getMallShoppingCartList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/mallShoppingCart/list?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data: {
      ...data,
      ___transferConfig: isToTransfer() ? {
        "language": getCurrentLocaleTransferCode(),
        "transferKeysConfig": JSON.stringify([
          [
            "data.dataList", "title"
          ],
          [
            "data.dataList", "specsInfo"
          ],
          [
            "data.dataList", "shopNick"
          ],



        ])
      } : undefined
    },
  });
}

// 商城加入购物车
export function tbGlobalAddItemsToCart(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/mallShoppingCart/add?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 商城修改1688购物车
export function tbGlobalItemsInCartModify(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/mallShoppingCart/modify?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}


// 删除1688购物车
export function tbGlobalItemsInCartDelete(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/mallShoppingCart/delete?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}



// 1688购物车预览
export function createOrder1688Preview(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/createOrderPreview?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data: {
      ...data,

    },
  });
}

// 1688购物车预览 v2
export function createOrderPreview2(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/createOrderPreview2?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 1688购物车创建
export function createCrossOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/createCrossOrder?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}

// 1688购物车创建 v2
export function newCreate1688Order2(data: any): AxiosPromise<unknown> {
  return request({
    url: `/mall/admin/alibabaGoods/createCrossOrder2?mall=1&hiddenErrTip=1&appCurrencyCode=${get(data, 'appCurrencyCode', '')}`,
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 1688购物车创建 v3
export function newCreate1688OrderV3(data: any): AxiosPromise<unknown> {
  return request({
    url: `/mall/admin/alibabaGoods/createCrossOrderV3?mall=1&hiddenErrTip=1&appCurrencyCode=${get(data, 'appCurrencyCode', '')}`,
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}


// 1688取消
export function alibabaTradeCancel(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/alibabaTradeCancel?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}
// 1688支付订单
export function alibabaTradePayProtocolPayPreparePay(data: any): AxiosPromise<unknown> {
  // 支付订单
  return request({
    url: "/mall/admin/alibabaGoods/alibabaTradePayProtocolPayPreparePay?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });

}

// 1688订单详情
export function alibabaTradeGetBuyerView(data: any): AxiosPromise<unknown> {
  // 1688订单详情
  return request({
    url: "/mall/admin/alibabaGoods/alibabaTradeGetBuyerView?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data: {
      ...data,
      ___transferConfig: isToTransfer() ? {
        "language": getCurrentLocaleTransferCode(),
        "transferKeysConfig": JSON.stringify([
          [
            "data.productItems", "name"
          ],
          [
            "data.productItems", "skuInfos", "name"
          ],
          [
            "data.productItems", "skuInfos", "value"
          ],

          // [
          //   "data.dataList","warehouseName"
          // ],

        ])
      } : undefined
    },
  });

}

// 1688订单详情 v2
export function alibabaTradeGetBuyerView2(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/alibabaTradeGetBuyerView2?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...data,
      ___transferConfig: isToTransfer() ? {
        "language": getCurrentLocaleTransferCode(),
        "transferKeysConfig": JSON.stringify([
          [
            "data.convertData.productItems", "name"
          ],
          [
            "data.convertData.productItems", "skuInfos", "name"
          ],
          [
            "data.convertData.productItems", "skuInfos", "value"
          ],
          [
            "data.productItems", "name"
          ],
          [
            "data.productItems", "skuInfos", "name"
          ],
          [
            "data.productItems", "skuInfos", "value"
          ],
        ])
      } : undefined
    },
  });
}

// 1688物流轨迹（买家视角）
export function alibabaTradeGetLogisticsTraceInfoBuyerView(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/alibabaTradeGetLogisticsTraceInfoBuyerView?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}


// 1688获取支付方式
export function geyShopPayMode(data: any): AxiosPromise<unknown> {
  // 1688订单详情
  return request({
    url: "/mall/admin/dealerShopPaymentConfig/queryPageList?collection=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });

}

// 更新电商用户信息
export function updateMallUserInfo(data: any): AxiosPromise<unknown> {
  // 更新电商用户信息
  return request({
    url: "/mall/portal/user/update?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });

}

// 查询收藏
export function queryUserCollectByUser(data: any): AxiosPromise<unknown> {
  return request({
    url: frontServiceUrl + "/favorites/list?mall=1",
    // baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}

// 查询浏览记录
export function queryRecentBehaviorItems(data: any): AxiosPromise<unknown> {
  return request({
    url: frontServiceUrl + "/behavior/recentItems?mall=1",
    method: "post",
    data,
  });
}

/** 取消收藏：collectionSite frontserver（与 curl /api/collectionSite/mall/frontserver/favorites/remove 一致） */
export function cancelUserCollect(data: {
  memberCode: string
  platformType: string
  itemId: string
  collectType: number
  appType: string
}): AxiosPromise<unknown> {
  const path = frontServiceUrl+"/favorites/remove";
  let url = path;
  try {
    const { hostname, origin } = window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      url = `${origin}${path}`;
    }
  } catch (_) {
    /* noop */
  }
  return request({
    url,
    method: "post",
    data,
  });
}


// 退款原因
export function alibabaTradeGetRefundReasonList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/alibabaTradeGetRefundReasonList?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}
// 退款申请
export function jyOrder1688CreateRefund(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/createRefund?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}

// 1688 退货物流渲染
export function alibabaReturnLogisticsRender(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/return-logistics-render?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 1688 退货物流下单
export function alibabaReturnLogisticsCreate(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/return-logistics-create?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 1688 退货物流支付
export function alibabaReturnLogisticsPay(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/return-logistics-pay?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店预下单
export function weidianBuyerConfirmOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/buyer/confirmOrder?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店创建订单
export function weidianBuyerCreateOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/buyer/createOrder?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店订单免密支付
export function weidianBuyerOrderPay(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/buyer/orderPay?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店查询采购支付单
export function queryPurchaseOrderByCodeMall(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/jyUserOrder/queryPurchaseOrderByCode?untransfer=true",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店澳洲支付（OnlyPay）
export function payJyUserPurchaseMallOrderV2ByMall(data: any): AxiosPromise<unknown> {
  return request({
    url: "/api/mall/jyUserOrder/purchasepay/v2?untransfer=true",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店取消订单
export function weidianBuyerCancelOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/buyer/cancelOrder?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店创建退款
export function weidianBuyerCreateRefund(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/buyer/createRefund?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店查询物流
export function weidianBuyerQueryLogistics(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/buyer/queryLogistics?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店订单详情
export function getWeidianOrderDetail(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/getWeidianOrderDetail?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}


export function alibabaProductTextTranslate(data: any): AxiosPromise<unknown> {
  const oldParam = get(data, "param", {});
  const sourceTextList = get(oldParam, "sourceTextList", "");
  const texts = Array.isArray(data?.texts)
    ? data.texts
    : String(sourceTextList)
        .split("\n")
        .map((item) => item.trim())
        .filter((item) => !!item);
  const languageMap = {
    "zh-Hant": "zh-tw",
    "zh-TW": "zh-tw",
  };
  const targetLanguageRaw =
    data?.targetLanguage || get(oldParam, "targetLanguage", "");
  const targetLanguage =
    languageMap[targetLanguageRaw] || targetLanguageRaw || "en";
  const sourceLanguage =
    data?.sourceLanguage || get(oldParam, "sourceLanguage", "zh");
  return request({
    url: frontServiceUrl + "/translate/batch?hiddenErrTip=1",
    method: "post", // 配置请求方式
    data: {
      isSystemText: typeof data?.isSystemText === "number" ? data.isSystemText : 0,
      texts,
      sourceLanguage,
      targetLanguage,
      appType: data?.appType || "react-mall-app",
    },
  });
}

// 专家代购待支付/状态订单列表
export function queryWaitPayOrderList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/waitPay/queryWaitPayOrderList?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...(data || {}),
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              ["data.dataList", "itemTitle"],
              ["data.dataList", "reason"],
              ["data.dataList", "remark"],
              ["data.dataList", "statusName"],
              ["data.dataList", "statusDesc"],
            ]),
          }
        : undefined,
    },
  });
}

export function saveWaitPayOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/waitPay/saveWaitPayOrder?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

export function closeWaitPayOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/waitPay/closeWaitPayOrder?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

export function queryByUserId(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/fundInfo/queryByUserId?mall=1&uncollection=true",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

export function getMemberMallPackageList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/member-package/query/orderPackagePageList?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            setPath: "null",
            transferKeysConfig: JSON.stringify([
              ["data", "list", "warehouseName"],
              ["data", "list", "itemName"],
              ["data", "list", "packageStatusName"],
              ["data", "list", "orderDetailResult", "title"],
              ["data", "list", "orderDetailResult", "spec"],
            ]),
          }
        : undefined,
    },
  });
}



export function getJyOrderPackagePageList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/member-package/query/jyOrderPackagePageList?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}




export function get1688GoodsList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/productSearchKeywordQuery?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}



export function get1688GoodsListByImg(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/productSearchImageQuery?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}



export function upload1688Img(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/productImageUpload?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}

export function get1688GoodsDetail(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/productSearchQueryProductDetail?mall=1", // 配置url
    baseURL: getMallBaseURL(),
    method: "post", // 配置请求方式
    data,
  });
}

export function productSearchQueryProductDetail(data: any): AxiosPromise<unknown> {
  return get1688GoodsDetail(data);
}

export function productSearchKeywordQuery(data: any): AxiosPromise<unknown> {
  return get1688GoodsList(data);
}

export function globalTbGoodsItemDetail(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/traffic-item-get?mall=1&transfertw=true",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// ===== 淘宝(海外淘宝)订单相关 =====

// 淘宝订单列表（对应移动端 getGlobalTbGoodsOrderList2）
export function queryGlobalTbGoodsOrderList2(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/overseas-order-query2?mall=1&untransfer=true",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...(data || {}),
      // 后端期望 pageNo 从 0 开始，这里直接透传（默认为 0）
      pageNo: typeof data?.pageNo === "number" ? data.pageNo : 0,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              ["data.convertData.dataList", "detailResults", "title"],
              ["data.convertData.dataList", "detailResults", "spec"],
              ["data.convertData.dataList", "shopName"],
              ["data.convertData.dataList", "orderStatusName"],
              ["data.convertData.dataList", "statusName"],
            ]),
          }
        : undefined,
    },
  });
}

// 淘宝首页订单统计
export function queryGlobalTbOrderStatistics(data?: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/order-statistics?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...(data || {}),
    },
  });
}

// 淘宝取消订单
export function cancelGlobalTbGoodsOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/purchase-order-cancel?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝支付订单
export function tbGlobalPurchaseOrderBatchPay(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/purchase-order-batchPay?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...data,
      param: {
        ...(data?.param || {}),
        hideToastTip: 1,
      },
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([["msg"]]),
          }
        : undefined,
    },
  });
}

// 淘宝支付订单（内采/流程单）
export function tbGlobalPurchaseOrderBatchPayProcess(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/process-purchase-order-batchPay?mall=1&hiddenErrTip=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...data,
      param: {
        ...(data?.param || {}),
        hideToastTip: 1,
      },
    },
  });
}

// 淘宝创建订单（全球购）v2
export function createGlobalTbGoodsOrder2(data: any): AxiosPromise<unknown> {
  const appCurrencyCode = data?.appCurrencyCode || "CNY";
  return request({
    url: `/mall/admin/overSeasTaoBao/purchase-order-create2?mall=1&hiddenErrTip=1&appCurrencyCode=${encodeURIComponent(appCurrencyCode)}`,
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝创建订单（全球购）流程单
export function createGlobalTbGoodsOrderProcess2(data: any): AxiosPromise<unknown> {
  const appCurrencyCode = data?.appCurrencyCode || "CNY";
  return request({
    url: `/mall/admin/overSeasTaoBao/process-purchase-order-create2?mall=1&hiddenErrTip=1&appCurrencyCode=${encodeURIComponent(appCurrencyCode)}`,
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝商品有效性校验（过期/下架）
export function tbGlobalCheckProductExpire(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/check-product-expire?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 服务费比例
export function queryPromotionScale(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/promotionProfile/queryPromotionScale?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝订单详情（用于物流等信息）
export function getTbOrgDetailData2(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/purchase-order-query2?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...data,
      param: {
        ...(data?.param || {}),
        hideToastTip: 1,
      },
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              ["data.purchaseOrders", "receiver.address"],
              ["data.purchaseOrders", "receiver.city"],
              ["data.purchaseOrders", "receiver.country"],
              ["data.purchaseOrders", "receiver.district"],
              ["data.purchaseOrders", "receiver.state"],
            ]),
          }
        : undefined,
    },
  });
}

// 淘宝物流详情（按采购子单ID查询）
export function getTbPurchaseOrderLogisticsDetail(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/purchase-order-getLogisticsDetail?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...data,
      param: {
        ...(data?.param || {}),
        hideToastTip: 1,
      },
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              ["data.pnmLogisticsDetails", "logisticsDesc"],
              ["data.pnmLogisticsDetails", "logisticsTraces", "statusDesc"],
              ["data.pnmLogisticsDetails", "logisticsTraces", "standerdDesc"],
              ["data.pnmLogisticsDetails", "logisticsPartner", "company"],
              ["data.pnmLogisticsDetails", "receiver", "address"],
              ["data.pnmLogisticsDetails", "receiver", "name"],
              ["data.pnmLogisticsDetails", "logisticsGoods", "title"],
              ["data.pnmLogisticsDetails", "logisticsGoods", "property"],
            ]),
          }
        : undefined,
    },
  });
}

// 淘宝退款渲染（申请退款前获取模板）
export function getGlobalTbGoodsRefundRender(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/refund-order-render?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

export function getGlobalTbProcessRefundOrderRender(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/process-refund-order-render?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝退款详情
export function getGlobalTbGoodsRefundDetail(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/refund-order-query?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝退款列表
export function queryGlobalTbGoodsRefundList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/refund-order-queryList?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝取消退款
export function cancelGlobalTbGoodsRefundOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/refund-order-cancel?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝提交退款
export function submitGlobalTbGoodsRefundOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/refund-order-submit?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

export function submitGlobalTbGoodsProcessRefundOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/process-refund-order-submit?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝退货物流渲染
export function tbReturnLogisticsRender(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/return-logistics-render?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝退货物流下单
export function tbReturnLogisticsCreate(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/return-logistics-create?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝退货物流支付
export function tbReturnLogisticsPay(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/overSeasTaoBao/return-logistics-pay?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 1688 退款售后列表
export function alibabaTradeRefundBuyerQueryOrderRefundList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/alibabaTradeRefundBuyerQueryOrderRefundList?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 1688 取消退款
export function alibabaTradeRefundBuyerCancel(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/alibabaGoods/alibabaTradeRefundBuyerCancel?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

export function jyPayDailyHistoryList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/fundInfoFlowManage/jyPayDailyHistory/list?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}


export function jyPayDailyHistoryExport(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/admin/fundInfoFlowManage/jyPayDailyHistory/export?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 淘宝包裹订单列表
export function getPackageTbOrderList(data: any): AxiosPromise<unknown> {
  const param = data?.param;
  if (param && typeof param.pageNo !== "undefined") {
    param.pageNum = param.pageNo + 1;
    delete param.pageNo;
  }
  const fetchData = param || data || {};

  return request({
    url: "/mall/admin/overSeasTaoBao/overSeasOrderPackagePageList?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data: {
      ...fetchData,
      authorization: getToken(),
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              ["data.list", "detailResults", "title"],
              ["data.list", "detailResults", "spec"],
              ["data.list", "shopName"],
            ]),
          }
        : undefined,
    },
  });
}


// 微店退款列表
export function queryGlobalWeidianGoodsRefundList(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall//weidian/refund-order-queryList?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

// 微店退货物流渲染（详情页）
export function weidianReturnLogisticsRender(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/return-logistics-render?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

//创建退货集运单

export function weidianReturnLogisticsCreate(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/return-logistics-create?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}

//支付退货集运单 

export function weidianReturnLogisticsPay(data: any): AxiosPromise<unknown> {
  return request({
    url: "/mall/weidian/return-logistics-pay?mall=1",
    baseURL: getMallBaseURL(),
    method: "post",
    data,
  });
}




